//summary of everything
import React, { useState, useEffect } from 'react';
import { Container, Alert, Table, Row, Col, Button } from 'react-bootstrap';
import { useNavigate, useParams, Link } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { getUserAccounts } from '../../app/slices/UserSlice';


import { getColor, toFactDate, fromFactDate, getFactDateRange, toDisplayDate, alterDate, isFactDate, toPercent, roundNum, toDurationFormat } from '../../util/ChartUtils';

import LeftNav from '../../components/LeftNav';
import AppList from './components/AppList'

const Selection = () => {
    const [errors, setErrors] = useState([]);
    const [account, setAccount] = useState(null);
    const [apps, setApps] = useState([]);
    const [range, setRange] = useState(null);


    let navigate = useNavigate();
    let { accountKey, startFactDate, endFactDate } = useParams();

    return (
        <Container fluid>
            <LeftNav isAnalytics={true} accountKey={accountKey} startFactDate={startFactDate} endFactDate={endFactDate} />
            <div>
                <div className='chart-card chart-card-table'>
                    <div className='chart-title mb-3'>Select an app to view analytics.</div>
                <AppList showErrors={false} showAddApp={true}/>
                </div>
            </div>
        </Container>
    )
}

export default Selection